
  import { Component, Watch, Vue }          from 'vue-property-decorator';
  import { Action, Getter }                 from 'vuex-class';
  import { EventBus,
           ConfigService,
           ConfigThemeService }             from '../..';

  @Component({
    name: 'FeedbackComponent',
  })
  export default class FeedbackComponent extends Vue {
  @Action('logSatisfaction', { namespace: 'conversationSession' }) logSatisfaction: any; 
  @Getter('currentSessionId', { namespace: 'conversationSession' }) currentSessionId!: string | undefined;

  rating: number = 0;
  feedbackText: string = this.defaultFeedbackMessage;
  showRating: boolean = false;
  showText: boolean = false;
  showFeedback: boolean = false;
  feedbackIsDisplayed: boolean = false;
  feedbackStarIsDisplayed: boolean = false;

  @Watch('currentSessionId')
  initFeedback(){
      // Reset feedback
      this.rating = 0;
      this.showRating = false;
      this.feedbackText = ConfigService.getDefaultFeedbackMessage();
      // Remove the feedback badge on refresh
      let feedbackElem: HTMLElement | null = document.getElementById('feedBack-strip-container-id');
      if(feedbackElem !== null && feedbackElem.classList.contains('is-displayed')){
        let feedbackPanelElem: HTMLElement | null = document.getElementById('feedBack-panel-content-id');
        this.checkingFeedbackPanelclosed(feedbackElem, feedbackPanelElem)
      }
  }

  get feedbackBannerColor() {
    return ConfigThemeService.getFeedbackComponentColor(this.$vuetify);
  }

  get feedbackTextColor() {
    return ConfigThemeService.getFeedbackTextColor(this.$vuetify);
  }

  get feedbackHeight() {
    return ConfigThemeService.getFeedbackHeight();
  }

  // Default message placed next to the rating
  get defaultFeedbackMessage() {
    return ConfigService.getDefaultFeedbackMessage();
  }

  // Default message to say thank you.
  get defaultThankFeedbackMessage() {
    return ConfigService.getDefaultThankFeedbackMessage();
  }

  // Waiting time between the closing of the evaluation panel and the moment to reopen it with Thank You.
  get feedbackPauseBeforeSayThankYouTime() {
    return 500; // 0.5 second
  }

  // Time of appearance of the message thank you
  get feedbackPauseBeforeSayGoodByeTime() {
    return 1500; // 1.5 seconds
  }

  get feedbackPanelTransitionTime() {
    return 1000; // 1000 = 1s = transition time
  }

  /** ********************************************************************* */
  /**                           TITTLE FOR BUTTONS                          */
  /** ********************************************************************* */

  get feedbackButtonTitle() {
    
    if (!this.feedbackIsDisplayed) {
      return ConfigService.getOpenFeedbackButtonTitle();
    } else {
      return ConfigService.getCloseFeedbackButtonTitle();
    }
  }

  /** ******************************************************************** */
  /**                      LIFECYCLE HOOKS FUNCTIONS                       */
  /** ******************************************************************** */

  created() {
    EventBus.$on('ON_DISPLAY_FEEDBACK_COMPONENT', () => this.manageFeedbackComponent());
    EventBus.$on('ON_CLOSE_FEEDBACK_PANEL', () => this.closeFeedbackPanel());
    EventBus.$on('ON_CLOSE_CONVERSATION_PANEL', () =>this.closeFeedbackPanel());
  }

  mounted() {
    this.$nextTick(() => {
      this.checkTextHideIsNeeded();
    });
    this.setAccessibility();
  }

  updated() {
    this.setAccessibility();
  }

  destroyed() {
    EventBus.$off('ON_DISPLAY_FEEDBACK_COMPONENT');
    EventBus.$off('ON_CLOSE_FEEDBACK_PANEL');
  }

  /** ******************************************************************** */
  /**                    COMPONENT STYLE FUNCTIONS                     */
  /** ******************************************************************** */

  get feedbackBannerStyle() {
    return {
      height : `${this.feedbackHeight}px`,
    }
  }

  /** ******************************************************************** */
  /**                    COMPONENT MANAGEMENT FUNCTIONS                     */
  /** ******************************************************************** */

  // Check if we need to hide the component text
  checkTextHideIsNeeded() {
    let containerMsgElement: HTMLElement | null = document.getElementById('chatbox-msg-list');
      let feedbackElem: HTMLElement | null = document.getElementById('feedBack-conversation-content-text-id');
      if(feedbackElem && containerMsgElement && feedbackElem.offsetWidth > containerMsgElement.offsetWidth) {
        // If the text is too long, it is resized and ellipsed.
        this.showText = false;
      }
  }

  // Gets the score back
  saveSurveyClose(score: number) {
      // Call logsatisfactionFaq
      this.logSatisfactionFaqWS(score);
      // We're closing the panel
      this.manageFeedbackPanel();
      setTimeout(this.sayThankYou, this.feedbackPanelTransitionTime + this.feedbackPauseBeforeSayThankYouTime);
  }

  /** Send the score to Faq
  * @param {*} score Soft's grade given by users
  *  Type number between 1 and 5
  */
  logSatisfactionFaqWS(score: number) {
      const sessionId: string | undefined = this.currentSessionId;
      this.logSatisfaction({ score, sessionId });
  }

  // Closes the panel and then the feedback component
  sayThankYou(){
    this.feedbackText = this.defaultThankFeedbackMessage;
    this.showRating = false;
    this.showText = true;

    this.$nextTick(() => {
      let containerMsgElement: HTMLElement | null = document.getElementById('chatbox-msg-list');
      let feedbackElem: HTMLElement | null = document.getElementById('feedBack-conversation-content-text-id');
      if(feedbackElem && containerMsgElement && feedbackElem.offsetWidth > containerMsgElement.offsetWidth) {
        // If the text is too long, it is resized and ellipsed.
        feedbackElem.style.maxWidth = (containerMsgElement.offsetWidth*0.8)+"px";
        feedbackElem.classList.add("ellipseText");
      }

      // Open the panel to thank them
      this.manageFeedbackPanel();
      
      this.showRating = false;

      // We wait two seconds and then we close everything
      setTimeout(this.sayGoodBye, this.feedbackPanelTransitionTime + this.feedbackPauseBeforeSayGoodByeTime); 
    });
    this.showText = false;
  }

  // Ferme le panel puis le feedback component
  sayGoodBye(){
    // Close the panel
    this.manageFeedbackPanel();
    // Close the feedback component
    setTimeout(this.manageFeedbackComponent, this.feedbackPanelTransitionTime);
  }

  // Display feedback component and manage animations related
  manageFeedbackComponent() {
    this.showFeedback = true;

    setTimeout(() => {
      let feedbackElem: HTMLElement | null = document.getElementById('feedBack-strip-container-id');
      let feedbackPanelElem: HTMLElement | null = document.getElementById('feedBack-panel-content-id');

      if(feedbackElem && feedbackElem.classList && feedbackPanelElem && feedbackPanelElem.classList) {
        // We're checking the status of our component.
        const isDisplayed: boolean = feedbackElem.classList.contains('is-displayed');
        // Reset transitions.
        feedbackElem.classList.remove('display-enter-active');
        feedbackElem.classList.remove('display-leave-active');
        // incoming transition
        if (!isDisplayed) {
          // applying `...-enter-active' for the incoming transition
          feedbackElem.classList.add('display-enter-active');
          // and applying the `.is-displayed' state.
          feedbackElem.classList.add('is-displayed');
          this.feedbackStarIsDisplayed = true;
        // outgoing transition
        } else {
          this.checkingFeedbackPanelclosed(feedbackElem, feedbackPanelElem)
          this.showRating = false;
          this.feedbackStarIsDisplayed = false;
        }
      }
    }, 1000);
  }

  // Remove the Feedback
  checkingFeedbackPanelclosed(feedbackElem: HTMLElement | null, feedbackPanelElem: HTMLElement | null) {
    if (feedbackPanelElem) {
      // We're checking to make sure the panel's closed.
      feedbackPanelElem.classList.remove('display-enter-active');
      feedbackPanelElem.classList.remove('display-leave-active');
      feedbackPanelElem.classList.remove('is-displayed');
    }
    
    if (feedbackElem) {
      // applying `...-leave-active' for the outgoing transition
      feedbackElem.classList.add('display-leave-active');
      // and applying the standard status.
      feedbackElem.classList.remove('is-displayed');
    }
    
  }

  // Open the FeedBack Panel and manage animations related
  manageFeedbackPanel() {
    let feedbackElem: HTMLElement | null = document.getElementById('feedBack-panel-content-id');
    if(feedbackElem &&  feedbackElem.classList) {

      // We're checking the status of our component.
      const isDisplayed: boolean = feedbackElem.classList.contains('is-displayed');
      // Reset transitions.
      feedbackElem.classList.remove('display-enter-active');
      feedbackElem.classList.remove('display-leave-active');

      if (!isDisplayed) {
          this.checkTextHideIsNeeded();
          // applying `...-enter-active' for the incoming transition
          feedbackElem.classList.add('display-enter-active');
          // and applying the `.is-displayed' state.
          feedbackElem.classList.add('is-displayed');
          this.feedbackIsDisplayed = true;
          this.showRating = true;
          this.showText = true;
      // outgoing transition
      } else {
          // applying `...-leave-active' for the outgoing transition
          feedbackElem.classList.add('display-leave-active');
          setTimeout(() => {
                this.showRating = false;
                this.showText = false;
            }, 1000); // Delay this action until the animation completes
          // and applying the standard status.
          feedbackElem.classList.remove('is-displayed');
          this.feedbackIsDisplayed = false;
      }
    }
  }

  // Close the FeedBack Panel and manage animations related
  closeFeedbackPanel() {
    let feedbackElem: HTMLElement | null = document.getElementById('feedBack-panel-content-id');
    if(feedbackElem &&  feedbackElem.classList) {

      // We're checking the status of our component.
      const isDisplayed: boolean = feedbackElem.classList.contains('is-displayed');
      // Reset transitions.
      feedbackElem.classList.remove('display-enter-active');
      feedbackElem.classList.remove('display-leave-active');

      if (isDisplayed) {
        // applying `...-leave-active' for the outgoing transition
        feedbackElem.classList.add('display-leave-active');
        // and applying the standard status.
        feedbackElem.classList.remove('is-displayed');
      }

      setTimeout(() => {
                this.showRating = false;
                this.showText = false;
                this.showFeedback = false;
            }, 1000); // Delay this action until the animation completes
    }
  }

  // Set the accessibility for the rating component
  setAccessibility() {
    this.$nextTick(() => {
      const ratingButtons = this.$el.querySelectorAll('.v-rating .v-icon');
      ratingButtons.forEach((button, index) => {

        // Add a span with the sr-only class to the button
        if (!button.querySelector('.sr-only')) {
          const span = document.createElement('span');
          span.classList.add('sr-only');
          let text = `Note de ${index + 1} sur 5`;
          span.textContent = text;
          button.appendChild(span);
        }

        // Add the title attribute to the button
        button.setAttribute('title', `Note de ${index + 1} sur 5`);
        
        // Add the tabindex attribute to the button
        button.setAttribute('tabindex', this.feedbackIsDisplayed ? '2' : '-1');
      });
    });
  }
}
